module.exports = __webpack_public_path__ + "72290743cbebacc3cbe4e5c8a576bff2.svg";